import { render } from "./send-notification.vue?vue&type=template&id=21ed3033"
import script from "./send-notification.vue?vue&type=script&lang=js"
export * from "./send-notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__